<template>
    <!-- contents -->
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{ pageTitle }} <span v-if="mode == 'view'">Detail</span></h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //contents_head -->
            <div :style="{ display: mode === 'list' ? 'block' : 'none' }">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w100">
                                <li class="tit_150">{{$t('FIELD.COUNTRY.NAME')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <fieldset class="ui_fieldset set_3">
                                        <div>
                                            <select class="slt_white w100p" v-model="rhqCd" disabled>
                                                <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p" v-model="corpNo" @change="changeCorpNo" disabled>
                                                <option value="">{{$t('FIELD.EUR.SELECT.CORPORATION')}} ({{$t('FIELD.FAST.DURATION.ALL')}})</option>
                                                <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p" v-model="countryCd" @change="changeCountryCd">
                                                <option value="">{{$t('FIELD.EUR.SELECT.COUNTRY')}} ({{$t('FIELD.FAST.DURATION.ALL')}})</option>
                                                <option v-for="code in countryCdList" :key="code.CODE" :value="code.CODE">{{code.CODE_NM}}</option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">
                                    {{ $t('FIELD.REQUEST.TYPE') }}
                                </li>
                                <li data-input-type="text" class="w100-200">
                                    <select class="slt_white w70p" v-model="srchReqTypeCd">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in requestTypeList"
                                            :key="'requestTypeList' + item.code"
                                            :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.APPROVAL.STATUS') }}</li>
                                <li data-input-type="text" class="w100-200">
                                    <select class="slt_white w70p" v-model="srchApprStatCd">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option v-for="item in apprStatusList"
                                            :key="'approvalStatusList' + item.code" :value="item.code"
                                        >
                                            {{ item.codeName }}
                                        </option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w40">
                                <li class="tit_150">{{ $t('FIELD.GLOBAL.REQUEST.DATE') }}</li>
                                <li data-input-type="date" class="w100-100">
                                    <fieldset class="ui_fieldset">
                                        <span class="date-wrap">
                                            <label>
                                                <input id="frDate" type="text" class="date_input w100p" readonly maxlength="10" />
                                                <a href="javascript:" class="in_btn" id="icoFrDate">
                                                    <i class="ico_date"></i>
                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                                </a>
                                            </label>
                                            <div class="fr_datepicker" id="fr-picker-container" />
                                        </span>
                                        <em class="txt_space"></em>
                                        <span class="date-wrap">
                                            <label>
                                                <input id="toDate" type="text" class="date_input w100p" readonly maxlength="10" />
                                                <a href="javascript:" class="in_btn" id="icoToDate">
                                                    <i class="ico_date"></i>
                                                    <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                                </a>
                                            </label>
                                            <div class="to_datepicker" id="to-picker-container" />
                                        </span>
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w30">
                                <li class="tit_70">{{$t('FIELD.BP.NUMBER')}}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="srchBpNo" @keyup.enter.stop="onSearch" placeholder="Enter a BP No" v-clearable />
                                    </span>
                                </li>
                            </ul>
                            <ul class="w30">
                                <li class="tit_70">{{$t('FIELD.FAST.MODEL')}}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="srchModelCd" @keyup.enter.stop="onSearch" :placeholder="$t('FIELD.GLOBAL.ETC.007')" v-clearable />
                                    </span>
                                </li>
                            </ul>

                        </div>
                        <div class="srch_grupR_bottom">
                            <span class="btn">
                                <a href="JavaScript:" class="btn_srch" @click="onSearch">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                            </span>
                        </div>
                    </article>
                </div>
                <!-- Grid -->
                <div class="grid_wrap">
                    <!-- Count -->
                    <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{totalCount}}</em></div>
                    <!-- Grid -->
                    <keep-alive>
                        <req-list-grid
                            :gridId="gridId"
                            :data="gridData"
                            :columns="columns"
                            :header="gridHeader"
                            :options="options"
                            :pageOptions="pageOptions"
                            :key="gridKey"
                            :click="contentClick"
                            :isTotalCount="false"
                        />
                    </keep-alive>
                </div>
            </div>
            <req-history-detail v-if="mode == 'view'" :pDetParams="pDetParams"></req-history-detail>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $                    from 'jquery';
import qs                   from 'query-string';
import Vue                  from 'vue';
import api                  from '@/service';
import axios                from 'axios';
import SKPBreadcrumbs       from '~vb/main/SKPBreadcrumbs';
import { SDLUtil }          from '@/utils';
import { EventBus }         from '@/utils/EventBus';
import { mapGetters }       from 'vuex';
import { HeaderHtmlRenderer } from '~c/GridCustomRenderer';
import moment               from 'moment';
import DatePicker           from '~c/DatePicker';
import ReqListGrid          from '~c/ToastGrid';
import ReqHistoryDetail     from './ReqApprHistoryDetail';
require('moment-jdateformatparser');

//const fetchCode = (groupCd, langCd) =>
//    axios.get(`${SDLUtil.API_URL}/noauth/eur/getCommonCodes.skp?groupCd=${groupCd}&langCd=${langCd}`);
export default {
    name: 'EurApprHistory',
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'req-list-grid'     : ReqListGrid,
        'req-history-detail': ReqHistoryDetail
    },
    computed: {
        ...mapGetters({
            loginRhq: 'getLoginRhq',
            corpCd: 'getCorpCd',
            langCd: 'getLangCd',
            loginNo: 'getLoginNo'
        })
    },
    data() {
        return {
            mode: 'list',
            pageTitle: '',
            totalCount: 0,
            rhqCd: '',
            corpNo: '',
            countryCd: '',
            rhqCdList: [],
            corpNoList: [],
            countryCdList: [],
            requestTypeList: [],
            apprStatusList: [],
            srchReqTypeCd:'',
            srchApprStatCd:'',
            srchBpNo: '',
            srchModelCd: '',
            srchStrDt: '',
            srchEndDt: '',
            pDetParams: {},
//            pReqSeq: '',
//            pBpNo: '',
            gridId: 'reqHistGrid',
            gridKey: 0,
            gridData: [],
            gridHeader: {
                columns: [
                    { name: 'CATE_MAIN_NM', renderer: HeaderHtmlRenderer }
                  , { name: 'CATE_SUB_NM',  renderer: HeaderHtmlRenderer }
                  , { name: 'APR_FRST_DT',  renderer: HeaderHtmlRenderer }
                  , { name: 'APR_SCND_DT',  renderer: HeaderHtmlRenderer }
                  , { name: 'CONT_SEND_YN', renderer: HeaderHtmlRenderer }
                  // CONT_SEND_YN
                ],
                height: 60
            },
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.REQUEST.DATE'),
                    name: 'REQ_DT',
                    align: 'center',
                    width: 112,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EUR.REQ.TYPE'), // New
                    name: 'REQ_TYPE_NM',
                    align: 'center',
                    width: 110,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EUR.APPR.TYPE'), // New
                    name: 'APR_TYPE_NM',
                    align: 'center',
                    width: 115,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.BP.NUMBER'),
                    name: 'BP_NO',
                    align: 'center',
                    width: 90,
                    sortable: true
                },
                {
//                    header: SDLUtil.getMsgProp('FIELD.MAJOR.PRODUCT.CATEGORY'),
                    header: 'Main Product<br>Category',
                    name: 'CATE_MAIN_NM',
                    align: 'center',
                    sortable: true
                },
                {
//                    header: SDLUtil.getMsgProp('FIELD.SUB.PRODUCT.CATEGORY'),
                    header: 'Sub Product<br>Category',
                    name: 'CATE_SUB_NM',
                    align: 'center',
                    width: 190,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                    name: 'MODEL_CD',
                    align: 'center',
                    width: 140,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.APPROVAL.STATUS'),
                    name: 'STATUS_NM',
                    align: 'center',
                    width: 110,
                    sortable: true
                },
                {
//                    header: SDLUtil.getMsgProp('FIELD.EUR.FRST.APPR_DATE'), // New
                    header: 'First<br>Approval Date',
                    name: 'APR_FRST_DT',
                    align: 'center',
                    width: 110,
                    sortable: true
                },
                {
//                    header: SDLUtil.getMsgProp('FIELD.EUR.SCND.APPR_DATE'), // New
                    header: 'Second<br>Approval Date',
                    name: 'APR_SCND_DT',
                    align: 'center',
                    width: 110,
                    sortable: true
                },
                {
//                    header: SDLUtil.getMsgProp('FIELD.EUR.SCND.APPR_DATE'), // New
                    header: 'Contents<br>Send Y/N',
                    name: 'CONT_SEND_YN',
                    align: 'center',
                    width: 90,
                    sortable: true
                }
            ],
            options: {
                scrollY: false,
                scrollX: false,
                rowHeight: 30,
            },
            pageOptions: {
                useClient: true,
                perPage: parseInt(localStorage.getItem('listRows') || 10),
            }
        };
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            return await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
        },
        onSearch() {
            SDLUtil.showLoadingBar(true);

            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let strDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFrDt = strDate ? moment(strDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';

            let searchParams = { 
                  corpNo        : this.corpNo
                , countryCd     : this.countryCd
                , srchReqTypeCd : this.srchReqTypeCd
                , srchApprStatCd: this.srchApprStatCd
                , srchBpNo      : this.srchBpNo
                , srchModelCd   : this.srchModelCd
                , srchStrDt     : searchFrDt 
                , srchEndDt     : searchToDt 
            };
            const url = `${SDLUtil.API_URL}/basis/eur/getReqApprHistories.skp`;
            return axios
                .post(url, qs.stringify(searchParams))
                .then(resp => {
                    console.log('Search.resp ===> ', resp);
                    this.gridData = resp.data.rows;
                    this.totalCount = this.gridData.length;
                    this.gridKey += 1;

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        async getCommonCodeList(v) {
            const codeResp = await api.getCommonCodeList(v);
            return codeResp;
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.loginNo);
            return codeResp;
        },
        getRhqCdList() {
            this.getCodeComboList(this.loginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                this.rhqCdList = data;
                this.rhqCd = this.loginRhq;
                this.getCorpNoList();
            });
        },
        changeCorpNo() {
            if (this.corpNo == '') { this.countryCdList = []; this.country = ''; }
            else                   this.getCountryCdList();
        },
        getCorpNoList() {
            this.getCodeComboList(this.rhqCd, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
                this.corpNo = this.corpCd;
                this.getCountryCdList();
            });
        },
        changeCountryCd() {
            if (this.countryCd == '') this.gridData = [];
            else                      this.onSearch();
        },
        async getCountryCdList() {
//            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/noauth/eur/getNationLangCodes.skp`,
                    qs.stringify({ groupCd: 'N', corpNo: this.corpNo })
                ).then(resp => {
//                    SDLUtil.showLoadingBar(false);
                    console.log('getcountryCds.resp ===> ', resp);
                    this.countryCdList = resp.data.rows;
                    if (this.countryCdList.length == 1) this.countryCd = this.countryCdList[0].CODE;
                    else                               this.countryCd = '';
                })
                .catch(err => {
//                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        contentClick(event) {
            let item = this.gridData[event.rowKey];
            console.log('item ==> ', item);
            this.pDetParams = item;
//            this.pReqSeq = item.REQ_SEQ;
//            this.pBpNo   = item.BP_NO;
            this.mode    = 'view';

//            const pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/adminSettingDetail`;
//            return this.$router.push({ path: pathUrl, query: {nationCd: data.NATION_CD}});
        },
        goListBack(data) {
            this.mode = 'list';
            this.onSearch();
        }
    },
    created() {
        EventBus.$on('goApproverList', this.goListBack);
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('goApproverList');
    },
    mounted() {
        this.getRhqCdList();
        this.getCommonCodeList('REQUEST_TYPE').then(data => {
            this.requestTypeList = data;
        });
        this.getCommonCodeList('APPR_STATUS').then(data => {
            this.apprStatusList = data;
        });

        this.$nextTick(() => {
            this.rangePicker = DatePicker.createRangeWithOpener(
                'fr-picker-container', 'frDate', 'icoFrDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'month').toDate(),
                (new moment()).toDate()
            );
            setTimeout(() => {
                this.onSearch();
            }, 400);
        });
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/ReqApprHistoryList.vue